import gsap from "gsap"
class parallax {
    constructor({ target, top, bottom, start, end }) {
        this.target = document.querySelectorAll(target)
        this.top = top,
        this.bottom = bottom
        this.start = start, 
        this.end = end,
        this.parallaxY()
    }
    parallaxY() {
        this.target.forEach((item) => {
          let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    scrub: true,
                    start: this.top,
                    end: this.bottom,
                },
            })
          this.timeLine(tl, item)
        })
    }

    timeLine(tlParallax, el){
        tlParallax.from(el, {
            yPercent: this.start,
            ease: 'none',
        })
        tlParallax.to(el, {
            yPercent: this.end,
            ease: 'none',
        })
    }
}

export default parallax